import { AuthTokenStorage } from "../AuthTokenStorage";

export const UseLogout = (): string | void => {
    window.location.href = "/";
    return AuthTokenStorage.set("");
};
